// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import { InstrumentConfiguration } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { TransferDisablementType } from '../../../../utils/LedgerApiClientV2';

const useDisableTransfersInstrumentConfiguration: () => UseMutationResult<
  void,
  string,
  {
    registrarServiceCid: ContractId<RegistrarService>;
    instrumentConfigurationCid: ContractId<InstrumentConfiguration>;
    disablementType: TransferDisablementType;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['disableTransfersInstrumentConfiguration', ledgerApi],
    mutationFn: async ({ registrarServiceCid, instrumentConfigurationCid, disablementType }) => {
      return ledgerApi.disableTransfersOnRegistryInstrumentConfiguration(
        registrarServiceCid,
        instrumentConfigurationCid,
        disablementType,
      );
    },
    retry: false,
  });
};

export default useDisableTransfersInstrumentConfiguration;
